module.exports = __webpack_public_path__ + "assets/img/globalcash_downApp.b4647c43.png";